import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/login.css'

import Popup from "../components/Popup";
import { AppContext } from "../../Context";
import Fetch, { Loader, dateToText, user_login } from "../inc/Fetch";
import { Img, Tasks } from "../components/Elements";
import { Input } from "../components/Form";


export default function Login() {
	
	const { t } = useTranslation();
	let navigate = useNavigate();
	const location = useLocation();
	
	const {siteData, successData, user, cartData} = useContext(AppContext); 
	const [success, setsuccess] = successData;
	const [cart, setcart] = cartData;

	const [loader, setloader] = useState(false);
	const [values, setvalues] = useState({ });


	async function submit(e) { 
		e.preventDefault();

		setloader(true);
		let res = await Fetch("customers/saveCart", { cart:cart, values:values, noUser:true });
		
		if (res?.success?._id) {
		

			localStorage.removeItem("cart");
			setcart([]);

			setTimeout(() => {

				window.history.replaceState(null, null, "/");
				navigate("/thanks", { state: { previousLocation: { pathname:"/" }, replace: true, order: res?.success } });

				setloader(false);
			}, 300);
			
		} else {
			
			setsuccess({ error: true, short:t("error",  { returnObjects: true })[res?.error] });
			
			setloader(false);
		}

		setloader(false);
		
	}

	useEffect(() => {
		if (location?.state?.data?.email) {

			setvalues({ email:location?.state?.data?.email, name: location?.state?.data?.name, img: location?.state?.data?.picture });
		}
	}, [location?.state?.data?.email])
	
	

	return (
		<>
			{loader && <Loader />}
			<Popup 
				className="loginPopBox reg"
			>
				<div className='leftLogin'>
					<h1>{t("no_user_title")}</h1>
					<p>{t("no_user_desc")}</p>
				</div>
				<form onSubmit={submit} className='loginForm'>

					

					<div className='loginFormIn'>
						<div className='loginButtonBox' >
							<Link to='/login' replace={true} state={{previousLocation: { pathname:"/"}}}  style={{marginTop:10}} type='button' className='btn gray login'>{t("login_title")}</Link>
						</div>

						<div className='loginOr' style={{marginBottom:14}}>
							<span>{t("or")}</span>
							<hr />
						</div>

						<Input
							// title="email"
							placeholder={`${t("reg_fullname")}..`}
							type="text"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									name: v
								}))
							}
							value={values?.name}
						/>

						<Input
							// title="email"
							placeholder={`${t("reg_email")}..`}
							type="email"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									email: v
								}))
							}
							value={values?.email}
						/>

						<Input
							// title="email"
							placeholder={`${t("phone")}..`}
							type="number"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									phone: v
								}))
							}
							value={values?.phone}
						/>

						<Input
							// title="email"
							placeholder={`${t("no_user_address")}..`}
							type="text"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									address: v
								}))
							}
							value={values?.address}
						/>

						<div className='loginButtonBox'>
							<button className='btn login'>{t("cart_send")}</button>
						</div>

						
					</div>
					

				</form>

				

			</Popup>
			
		</>
	)
}
